module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesUrban.82f8906.webp";